/**
 * UN/ARCHIVE Global JavaScript
 * Core functionality loaded early
 */

(function() {
  'use strict';

  // Remove no-js class
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  // Add touch device class
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    document.documentElement.classList.add('touch');
  } else {
    document.documentElement.classList.add('no-touch');
  }

  // Detect user preference for reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  
  if (prefersReducedMotion.matches) {
    document.documentElement.classList.add('reduce-motion');
  }

  // Simple focus visible polyfill
  let hadKeyboardEvent = false;
  
  const handleFirstTab = (e) => {
    if (e.key === 'Tab') {
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', handleFirstTab);
    }
  };
  
  window.addEventListener('keydown', handleFirstTab);

  // Performance mark
  if (window.performance && window.performance.mark) {
    window.performance.mark('unarchive-theme-start');
  }

})();
